// PRD 14 §2.2 #8 — Bold / Italic / Underline / Bullet List toolbar driven by
// document.execCommand on the sibling contenteditable editor. Same pattern as
// the Notices / Health-Whitepaper editors. No new dependency.
//
// onMouseDown.preventDefault() prevents focus stealing — the editor selection
// must stay live so execCommand applies to the user's last cursor position.

import { useTranslation } from 'react-i18next';

export type RteCommand = 'bold' | 'italic' | 'underline' | 'insertUnorderedList';

interface RteToolbarProps {
  onCommand: (cmd: RteCommand) => void;
}

const BUTTON_STYLE: React.CSSProperties = {
  height: 28,
  padding: '0 10px',
};

export function RteToolbar({ onCommand }: RteToolbarProps) {
  const { t } = useTranslation('terms');

  const fire = (cmd: RteCommand) => (e: React.MouseEvent) => {
    e.preventDefault();
    onCommand(cmd);
  };

  return (
    <div
      style={{
        display: 'flex',
        gap: 4,
        padding: 6,
        border: '1px solid var(--border)',
        borderBottom: 'none',
        borderRadius: 'var(--radius-sm) var(--radius-sm) 0 0',
        background: 'var(--muted)',
      }}
    >
      <button
        type="button"
        className="btn btn-default btn-secondary"
        style={{ ...BUTTON_STYLE, fontWeight: 700 }}
        title={t('form.toolbar.bold')}
        onMouseDown={fire('bold')}
      >
        B
      </button>
      <button
        type="button"
        className="btn btn-default btn-secondary"
        style={{ ...BUTTON_STYLE, fontStyle: 'italic' }}
        title={t('form.toolbar.italic')}
        onMouseDown={fire('italic')}
      >
        I
      </button>
      <button
        type="button"
        className="btn btn-default btn-secondary"
        style={{ ...BUTTON_STYLE, textDecoration: 'underline' }}
        title={t('form.toolbar.underline')}
        onMouseDown={fire('underline')}
      >
        U
      </button>
      <button
        type="button"
        className="btn btn-default btn-secondary"
        style={BUTTON_STYLE}
        title={t('form.toolbar.bulletList')}
        onMouseDown={fire('insertUnorderedList')}
      >
        • {t('form.toolbar.bulletList')}
      </button>
    </div>
  );
}
